import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { CalendarEvent } from '../../types/calendar.types';
import { useSTKContext } from '@/context/context';

export const useCalendarEvents = (enabled: boolean, requestBody: { startTime: string; endTime: string }) => {
  const { apiClient } = useSTKContext();
  return useQuery<AxiosResponse<CalendarEvent[]>>({
    queryKey: ['calendar-events', requestBody.startTime, requestBody.endTime],
    queryFn: () => apiClient.get<CalendarEvent[]>('/calendars', { params: requestBody }),
    enabled,
    keepPreviousData: true,
  });
};
